import * as types from '../constants';

export function getQueryExamples() {
  return {
    type: types.GET_QUERY_EXAMPLES,
  };
}

export function setCreateSPQLQueryStatus(status) {
  return {
    type: types.SET_CREATE_SPQL_QUERY_STATUS,
    payload: status,
  };
}

export function getDeepScanMetadata() {
  return {
    type: types.GET_DEEP_SCAN_METADATA,
  };
}

export function changeSPQLQueryValidationMessage(message) {
  return {
    type: types.CHANGE_SPQL_QUERY_VALIDATION_MESSAGE,
    payload: message,
  };
}

export function resetDeepScanToInitialState() {
  return {
    type: types.RESET_DEEP_SCAN_TO_INITIAL_STATE,
  };
}

export function deleteSPQLQuery(uuid) {
  return {
    type: types.DELETE_SPQL_QUERY,
    uuid,
  };
}

export function updateSPQLQuery({
  uuid,
  query,
  scope,
  sorting,
  name,
  description,
}) {
  return {
    type: types.UPDATE_SPQL_QUERY,
    uuid,
    scope,
    query,
    sorting,
    name,
    description,
  };
}

export function createSPQLQuery({ query, sorting, name, description }) {
  return {
    type: types.CREATE_SPQL_QUERY,
    query,
    sorting,
    name,
    description,
  };
}

export function getSavedSPQLQueries() {
  return {
    type: types.GET_SAVED_SPQL_QUERIES,
  };
}

export function getRecentlyRanSPQLQueries() {
  return {
    type: types.GET_RECENTLY_RAN_SPQL_QUERIES,
  };
}

export function getDeepScan({ query, sort, limit, skip }) {
  return {
    type: types.GET_DEEP_SCAN,
    query,
    sort,
    limit,
    skip,
  };
}

export function changeSPQLQuery(query) {
  return {
    type: types.CHANGE_SPQL_QUERY,
    payload: query,
  };
}

export function changeSPQLSorting(sorting) {
  return {
    type: types.CHANGE_SPQL_SORTING,
    payload: sorting,
  };
}

export function changeSPQLSelectedColumns(columns) {
  return {
    type: types.CHANGE_SPQL_SELECTED_COLUMNS,
    payload: columns,
  };
}
